
import iconPaths from '~/components/atoms/Icon/utils/icon.paths'
import { theme } from '~/tailwind.config.js'

const fallbackIcon = iconPaths.checkmark

const sizes = {
  small: 0.8,
  regular: 1,
  large: 2,
  xl: 4
}

const iconProps = {
  name: {
    type: String
  },
  size: {
    type: [String, Number],
    default: 'regular',
    validator: (value) => {
      return value in sizes || typeof value === 'number'
    }
  },
  theme: {
    type: String,
    default: '',
    validator: (value) => {
      return [
        '',
        'black',
        'off-black',
        'white',
        'grey-light',
        'legacy-blue'
      ].includes(value)
    }
  },
  gradient: {
    type: Boolean,
    default: false
  }
}

const Svg = {
  name: 'IconSvg',
  props: iconProps,
  render (createElement) {
    return createElement(
      'svg',
      {
        class: 'BaseIconSvg',
        attrs: this.$attrs
      },
      this.$slots.default
    )
  }
}

export default {
  props: iconProps,
  computed: {
    icon () {
      if (this.name && this.name in iconPaths) {
        return iconPaths[this.name]
      }

      // eslint-disable-next-line no-console
      console.warn("The value you provided to the name prop can't be found")
      return fallbackIcon
    },

    computedStyle () {
      const size = typeof this.size === 'number' ? this.size : sizes[this.size]
      const style = {
        style: {
          height: `${size}em`
        }
      }

      if (this.theme) style.style.fill = theme.extend.colors[this.theme] || 'currentColor'
      else if (this.gradient) style.style.fill = 'url(#MyGradient)'

      return style
    },

    viewBox () {
      return this.icon.viewBox
    },

    gradientStyle () {
      return `
      <defs>
        <linearGradient id="MyGradient" gradientUnits="userSpaceOnUse" gradientTransform="rotate(20)">
          <stop offset="0%" stop-color="${theme.extend.colors.purple}" />
          <stop offset="60%" stop-color="${theme.extend.colors.blue}" />
          <stop offset="100%" stop-color="${theme.extend.colors['blue-light']}" />
        </linearGradient>
      </defs>
      `
    },

    innerHTML () {
      let innerHTML = this.icon.path
      
      if (this.gradient) innerHTML = `${this.gradientStyle}${innerHTML}`

      return innerHTML
    }
  },

  render (createElement) {
    return createElement(Svg, {
      staticClass: 'BaseIcon',
      attrs: {
        viewBox: this.viewBox,
        role: 'presentation',
        preserveAspectRatio: 'xMidYMid meet',
        focusable: false
      },
      domProps: {
        innerHTML: this.innerHTML
      },
      ...this.computedStyle
    })
  }
}
